exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* smartphones, iPhone, portrait 480x320 phones */\n/* portrait e-readers (Nook/Kindle), smaller tablets @ 600 or @ 640 wide. */\n/* portrait tablets, portrait iPad, landscape e-readers, landscape 800x480 or 854x480 phones */\n/* tablet, landscape iPad, lo-res laptops ands desktops */\n/* big landscape tablets, laptops, and desktops */\n/* hi-res laptops and desktops */\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.scss
// module id = ./src/app/app.component.scss
// module chunks = main